module.exports = {
  messages: {
    login: {
      metaTitle: '用户登录, 访问ASOGrow账户 | ASOGrow',
      metaKeywords: '用户登录、账户访问',
      metaDesc: '登录ASOGrow平台，享受全自动ASO优化服务，管理您的应用优化项目与推广数据。',
      signUpBtn: '注册',
      loginText: '登录',
      email: '邮箱',
      phone: '手机',
      emailInput: '请输入邮箱地址',
      password: '登录密码',
      passInput: '密码至少需包含 6 个字符',
      forgetPassword: '忘记密码？',
      invalidErr: '登录账号或者密码错误，请重新输入！',
      emptyErr: '此项不可为空！',
      formatErr: '请输入正确的邮箱地址',
      registerSuccess: '注册成功',
      tip1: '该电话号码首次在平台上使用。',
      tip2: '您已成功注册新帐户',
      next: '下一步',
      ninfo: '无通知',
      send: '发送',
      resend: '重新发送',
    },
    gLogin: {
      loginText: '欢迎使用ASOGrow平台',
      contact: '联系信息',
      contactErr: '请填写您的联系信息。',
      link: '产品链接(Google Play)',
      linkEmpErr: '请填写您需要推广的产品链接。',
      linkErr: '请填写合法的Google Play产品链接。',
      urlErr: 'URL格式错误',
      linkInput: '请输入正确的应用商店链接',
      loginBtn: '生成专属的推广任务',
      login: '谷歌登录',
      register: '谷歌注册',
      text: '或',
      nofind: '在商店中找不到应用程序',
      logBtnText: '使用 Google 账号登录',
      regBtnText: '使用 Google 账号注册',
      contactTip: '请确保填写正确联系方式，工作人员将添加并发送免费体验券。',
      jump: '跳过',
      warnTitle: '终于等到您！',
      warnContent: '如果您对如何快速推广应用和获取用户感兴趣的话，请点击下方按钮联系我们！',
      contactTip2: '推荐使用WhatsApp联系我们哦',
    },
    register: {
      metaTitle: '用户注册, ASOGrow账号创建 | ASOGrow',
      metaKeywords: '用户注册、账号创建、ASO服务、应用推广',
      metaDesc: '轻松创建ASOGrow账号，开启应用优化与推广之旅，享受专业ASO服务',
      name: '姓名',
      email: '邮箱',
      emailInput: '请输入邮箱地址',
      password: '密码',
      passInput: '密码至少需包含 6 个字符',
      comPassword: '确认密码',
      comPassInput: '请再次输入密码',
      contact: '联系信息',
      code: '验证码',
      codeInput: '点击可刷新验证码',
      tip1: '我已经超过十八岁',
      tip2: '注册即表示你同意 ASOGrow 的',
      tip22: '《隐私政策》',
      tip222: '和',
      tip2222: '《服务条款》',
      tip3: '我同意接收营销邮件',
      btn: '注册',
      emptyErr: '此项不可为空',
      emailFormatErr: '请输入正确的邮箱',
      emailExit: '注册邮箱已存在',
      passErr: '请输入密码',
      nameErr: '名称中只允许字母、数字、空格和中文',
      passSameErr: '请再次输入相同的密码',
      passRegErr: '仅支持 6–16 位字母和数字',
      contactTip: '请确保填写正确联系方式，工作人员将添加并发送免费体验券。',
      phoneFormatErr: '手机号码（可选）',
      verificationCodeEmpty: '请输入验证码。',
      verificationCodeWrong: '验证码错误。',
      verificationCodeDigit: '请输入6位验证码。',
      verificationCodeSend: '超时，请重新发送验证码',
      codeSended: '验证码已发送到您的手机，请仔细检查',
      phoneRegistered: '电话号码已注册，请直接登录！',
      regTip: '创建新账户',
      codeAgain: '稍后再试',
      codeAgain2:'发送过于频繁，请稍后重试 ',
      phoneTip: '请输入手机号码',
      phoneExit: '此手机号码已注册',
      phoneErr1: '只能输入数字',
      phoneErr2: '请输入正确的电话号码',
      phoneErr3: '最多输入20个数字',
      phoneTip2: '手机号码',
      contact2: '请输入联系信息',
      andapp: '安卓应用',
      lastStep: '最后一步：填写信息',
      fullname: '请输入您的联系名字',
      emaTip: '请输入您的电子邮箱，以便接收通知',
      appname: '请输入应用名称/包名',
      btnT: '探索免费的ASO增长之旅',
    },
    registers: {
      title: '注册成功!',
      subtitle: '注册邮箱：',
      subtitle2: '注册手机：',
      content1: '请点击邮件的激活链接。如果收件箱没有邮',
      content2: '件,请注意检查',
      content22: '垃圾箱',
      content222: '。',
      btn: '去邮箱查看',
      link: '没有收到邮件？',
    },
    forget: {
      title: '找回密码',
      subTitle: '请输入注册邮箱，我们将向该邮箱发送密码重置邮件。',
      email: '已注册邮箱',
      emailInput: '请输入邮箱地址',
      code: '验证码',
      confirm: '确定',
      back: '返回登录',
      codeErr: '请输入正确的验证码',
      emptyErr: '邮箱、验证码不可为空',
      noEmail: '此邮箱未注册，请输入正确的邮箱地址',
      formatErr: '请输入正确的邮箱地址',
    },
    forgets: {
      title: '重置密码',
      subtitle: '请登录邮箱进行检查:',
      content1: '我们已经给你发送了重置密码的邮件，请点击邮件内链接进行重置。',
      content2: '如果你无法找到邮件，请检查收件箱。',
      btn: '去邮箱查看',
    },
    receive: {
      title: '没有收到邮件？',
      subtitle: '请尝试以下解决方案：',
      tip1: '有可能网络延迟，请在几分钟后再次检查邮箱；',
      tip2: '检查',
      tip22: '垃圾箱',
      tip222: '；',
      tip3: '请仔细核对邮箱，确保填写正确：',
      tip4: '点击此',
      tip44: '重发邮件；',
      tip5: '点击右下方的服务按钮与我们联系。',
      btn: '返回登录',
    },
    activate: {
      title: '请激活你的账号',
      subtitle: '请检查你的邮箱：',
      tip1: '请点击激活邮件的激活链接；',
      tip2: '如果收件箱没有激活邮件请检查',
      tip22: '垃圾箱',
      tip222: '。',
      btn: '返回登录',
      btn2: '没有收到邮件？',
    },
    tipError: {
      netErr: '网络异常',
      codeErr: '请输入正确的验证码。',
      emailNotAct: '电子邮件未激活',
      loginErr: '邮箱或密码错误',
      timeout: '请求超时，请重试',
      emailExit: '创建帐户失败,已存在具有此电子邮件地址的用户',
      ageErr: '要成为广告商，您必须年满18岁，并接受ASOGrow平台的条款和条件。',
      limitErr: '每个账户每天只能重设一次密码，请在您的邮箱查收新密码。',
      emailFail: '发送邮件失败，请联系客服。',
      accountNotActive: '账户尚未激活',
      srvErr: '未知错误，请联系客服处理。',
      postOnly: '未知错误，请联系客服处理。',
      pswDiff: '密码错误',
      emailExists: '此邮箱已注册，请使用新邮箱进行注册。',
      emailNotExists: '此邮箱尚未注册。',
      alreadyVerify: '未知错误，请联系客服处理。',
      unVerifyErr: '未知错误，请联系客服处理。',
      emailCountLimit: '未知错误，请联系客服处理。',
      phoneCodeErr: '验证码不正确',
      internalErr: '未知错误，请稍后重试或使用电子邮件注册',
      phoneCodeFormatErr: '手机号码格式错误',
      invalidCodeErr: '验证码无效',
      sendErr1: "以下是可用于向客户服务反馈以解决问题的故障排除信息。",
      sendErr2: "刷新不能解决这个问题？点击按钮，联系客服。",
      sendErr3: "错误消息",
      sendErr4: "联系我们",
      emptyErr: '此项不可为空！',
      emptyErr2: '评论不可为空！',
      capErr: '为了更好的投放效果，每日上限（Daily Cap）不应低于 3',
      limitErr2: '请输入不超过 200 个字符',
      notNumErr: '输入值不是数字',
      limitErr3: '请输入不超过 500 个字符',
      limitErr4: '评论中不得包含分号 (;)。',
      limitErr5: '评论数量与每日上限必须一致',
      limitErr6: '文件大小不超过3MB。',
      limitErr7: '只能上传一个文件',
      limitErr8: '请上传.xls、.xlsx、.txt或.csv格式的文件。',
      limitErr9: '文件为空',
      limitErr10: '文件类型错误',
    },
    home: {
      tip0: '你好',
      tip1: '立即充值，解锁高额奖金',
      tip2: '限时充值折扣，优惠不容错过',
      tip3: '查看详情',
      tip4: '欢迎来到 ASOGrow',
      tip5: '  一站式应用商店数据优化平台，自动执行、快速交付',
      tip6: '快捷入口',
      tip7: '我的应用',
      tip8: '点击快速开启任务投放',
      tip9: '查看您的余额变动记录',
      tip10: '充值到账后，即可快速启动推广任务',
      tip11: '联系我们，获取免费试用！',
      tip13: '2. 您的广告将在哪里展示？',
      tip14: '3. 什么是关键词搜索推广任务？',
      tip15: '4. 什么是应用的关键词排名？',
      tip16: '5. 什么是评分与评论推广任务？',
      tip17: '6. 我们如何计算价格？',
      tip18: '添加应用',
      tip19: '请输入正确的应用商店链接',
      tip20: '请输入正确的应用商店产品链接',
      tip21: "获取您的定制化应用推广方案",
      tip22: '当应用达成目标阶段后，可重点优化关键词搜索排名表现。',
      tip23: '立即联系客户经理',
      tip24: '正在投放的任务',
      tip25: '数据统计',
      tip26: '推广任务',
      tip27: '开发者',
      tip28: '类别',
      tip29: '安装',
      tip30: '评论',
      tip31: '评分',
      tip32: '实际值：',
      tip33: '获取更多自然流量用户',
      tip34: '获取更多五星好评',
      tip35: '提高应用评分',
      tip36: 'Lv3 目标: ',
      tip37: '安装量目标等级',
      tip38: "为实现更自然的下载增长，我们将根据应用当前安装量制定三级推广策略。",
      tip39: '为什么下载量对您的应用很重要？',
      tip40: '充足的下载量有助于提升应用可见性，并扩展关键词覆盖范围。',
      tip41: '下载量与用户互动越高，应用的排名表现越优。',
      tip42: '评论目标等级',
      tip43: '评论与安装量呈强正相关，因此我们将评论目标设置为与安装目标一致的三个层级。',
      tip44: '为什么您的应用需要更多好评？',
      tip45: '用户通常依赖应用的评论与评分来选择下载应用，因此应重点提升正面评价数量。',
      tip46: '当评论数量达到目标等级后，评分将趋于稳定，不易发生明显波动。',
      tip47: '评分目标',
      tip48: '评分是关键词搜索排名中的一个重要因素。',
      tip49: 'Google Play已启用评分筛选机制，用户可按 4.0/4.5 星以上过滤结果，这迫使应用产品必须维持高评分，否则将大幅减少搜索曝光机会。',
      tip50: '基于这一机制，我们将评分目标设定为5.0星。',
      tip51: '在Google Play中查看',
      tip52: '国家',
      tip53: '刷新',
      tip54: '删除',
      tip55: '等级',
      tip56: '目标',
      tip57: '删除全部',
      tip58: '导入',
      tip59: '',
      tip60: '，获取专属增长方案',
      tip61: '推广任务',
      tip62: '余额记录',
      tip63: '充值',
      tip64: '查看更多',
      tip65: 'ASOGrow 用户指南｜Google Play ASO 平台',
      tip66: '我的账户',
      tip67: 'Lv1 目标：',
      tip68: 'Lv2 目标：',
      tip69: '提示：',
      tip70: '余额',
      tip71: '通知',
      tip72: '目标：5',
      tip73: '，',
      tip74: '。',
      tip75: '好的',
    },
    myCampaign: {
      list1: '复制',
      list2: '暂停',
      list3: '取消',
      list4: '已消耗数量',
      list5: '状态',
      list6: '类型',
      list7: '开发者名字',
      list8: '任务 ID',
      list9: '包名',
      list10: '暂无数据',
      list11: '应用',
      list12: '推广任务类型',
      list13: '组合推广任务',
      list14: '推广日期',
      list15: '投放金额',
      list155: '金额',
      list16: '已消耗金额',
      list17: '投放数据',
      list18: '推广',
      list19: '图标',
      list20: '业务类型',
      list21: '总数量上限',
      list22: '推广价格',
      list23: '请确认推广任务信息',
      list24: '如果确认,将从您的账户余额中扣除',
      list25: '',
      list26: '您可以立即充值并开始推广任务。',
      list27: '确认',
      list28: '通过 Stripe 充值',
      list29: '支付成功，推广任务已激活',
      list30: '查看推广任务',
      list31: '余额不足，推广任务无法启动',
      list32: '如有任何疑问，请联系我们。',
      list33: "恭喜！您已获得5美元试用金！",
      list34: '您的推广任务已准备就绪，立即开始吧！',
      list35: '立即联系我们，领取专属奖励',
      list36: "* 为了更好地为您提供服务，请填写取消推广任务的原因，我们将持续优化改进。",
      list37: '点击此处推广您的应用',
      list38: '任务确认',
      list39: '付款后，推广任务将在 ',// teshu
      list40: '开始',// teshu
      list41: '该订单的折扣后金额是',
      list42: '操作',
      list43: '查询',
      list44: '创建任务',
      list45: '导出',
      list46: '导出详细数据',
      list47: '点击导出详细数据',
      list51: '未消耗使用的金额将在推广任务结束后退还至账户余额。',
      list52: '若超过一天未出现数据，请及时联系我们，数据可能会有延迟。',
      list53: '关闭',
      list54: '保存草稿，稍后提交支付',
      list55: '开始推广',
      list56: "您已获得5美元试用金！",
      list57: "注意:",
    },
    createCampaign:{
      create1: '应用安装',
      create2: '关键词安装',
      create3: '自定义评论',
      create4: '保障性评论',
      create5: '评论点赞/点踩',
      create6: '社交媒体',
      create7: '国家/地区',
      create8: '选择一个应用或',
      create9: '请选择目标投放国家',
      create10: '请选择国家',
      create11: '时区',
      create12: '选择每日投放预算更新的时区。',
      create13: '推广日期',
      create14: '设置投放计划的有效日期范围',
      create15: '广告图片素材',
      create16: '图片（.jpg、.png），最大 500 KB。宽 × 高：912 × 400。',
      create17: '搜索关键词',
      create21: '每日数量上限',
      create22: '请填写整数数值',
      create23: '总预算 = 每日预算 × 推广天数',
      create24: '投放价格',
      create25: '投放单价',
      create26: '组合套餐详情',
      create27: '安装并打开',
      create28: '五星评分',
      create29: '五星评分和评论',
      create30: '新增一行',
      create31: '下载，打开',// Download,Open teshu
      create32: '基础信息',
      create33: '每日上限 = 自定义评论数量/推广天数',
      create34: `预算总量不能超过评论数量`,
      create344: '建议：预算数量 = 评论内容数的一半',
      create35: '了解我们的积分墙应用',
      create37: "AI 将根据以下期望特征，并结合应用在Google Play的描述，生成合适的评论内容。每条评论不超过 400 个单词字符。",
      create38: '语言',
      create39: '应用分类',
      create40: '评论的语气',
      create41: '产品特点',
      create42: '您可以输入多个产品特征，用“,/;”分隔。每条评论内容将随机选取三个产品特征。',
      create45: '截图',
      create46: '社媒平台',
      create47: '目标',
      create48: '账号名称',
      create49: '账号主页链接',
      create50: '账号头像',
      create51: '确认后，系统将根据该方案优化您的应用。',
      create53: '当前国家不支持此业务类型',
      create54: '应用',
      create55: '添加新应用',
      create56: '免费试用服务目前仅支持印度尼西亚、印度和菲律宾投放地区。',
      create57: '上传评论文件',
      create58: '选择广告图片素材',
      create59: '下载，打开',
      create60: '下载、打开与评分',
      create61: '下载、打开与评分及评论',
      create62: '关键词安装',
      create63: '搜索关键词、安装并打开',
      create64: '自定义评论',
      create65: '安装、打开、评分与自定义评论',
      create66: '关键词安装与评分',
      create67: '搜索关键词、安装并打开及评分',
      create68: '关键词安装与自定义评论',
      create69: '搜索关键词、安装并打开、评分与自定义评论',
      create70: '评分',
      create71: '评论',
      create72: '组合套餐和媒体服务不支持免费试用。',
      create73: '总计',
      create74: '组合推广任务',
      create75: '快速找到任务来源',
      create76: '添加新应用',
      create77: '推广天数',
      create78: '推广任务将在2个工作日内开始',
      create79: '由AI生成',
      create80: '导入评论',
      create81: '批量复制',
      create82: '请使用以下文件格式：*.xls / *.txt / *.csv / *.xlsx',
      create83: '每条评论不超过500个字符；请使用 ; 或 / 分隔每条评论',
      create84: '除了在页面上直接编辑评论，您还可以使用模板批量导入评论',
      create85: '点击',
      create86: '下载批量导入模版',
      create87: '确认',
      create88: '重复评论和空值将被自动删除，点击确认后评论将添加到已有评论中。',
      create89: '充值完成后，您可以在此页面查看并创建该推广任务',
      create90: '评论关键词',
      create91: '关键词',
      create92: '1. 请填写您希望用户在评论中包含的关键词',
      create93: '2. 每条评论关键词长度不得超过180个字符',
      create94: '为保证用户搜索可见性，请确保您的应用在该关键词中排名前250位。',
      create95: "输入内容请勿包含引号、/、# 等特殊字符",
      create96: '每个搜索关键词不得超过20个字符。',
      create97: '添加',
      create98: '一次最多只能提交20个关键词',
      create99: '自定义评论数量必须大于或等于推广天数总和',
      create100: '关键词下载',
      create101: '免费上限最多为5',
      create102: '请填写谷歌应用商店评论用户的用户名',
      create103: '请上传需要点赞的评论截图',
      create104: '点击调整图片 ',
      create105: '这可能会影响广告投放效果',
      create106: '以本网站为准',
      create107: '计费类型',
      create108: '投放地区 / 地域',
      create109: '返回',
      create110: '任务详情',
      create111: '例子',
      create112: '可自定义的推广任务包含安装、评分和评论',
      create113: '通过100%真实用户安装，推动自然增长',
      create114: '通过定向安装提升关键词排名和自然流量',
      create115: '提升应用评分，建立用户信任并促进下载',
      create116: '获取正面用户评论，影响潜在客户决策',
      create117: '发布定制化评论，突出应用核心功能',
      create118: '获取自定义评论，并保证在Google Play上的有效展示时长，无展示则不收费',
      create119: '增加关键评论的点赞数，提升其曝光度与信任证明',
      create120: `我们引导真实用户在Google Play上为您的应用留下真实评价， 
      并提供可见性保障，确保这些评价在3天内持续可见。我们的服务专注于通过真实反馈提升应用的可信度。`,
      create121: `这项服务可提升您应用在应用商店中正面评价的“有帮助”或“点赞”投票数量。
      通过增强优质评价的互动度，提高其曝光率与可信度，从而影响潜在用户的下载决策，提升应用转化率。`,
      create122: `依托精准增长策略，提升 TikTok、Facebook、X（原 Twitter）及 Google Maps 等平台粉丝规模，
      并通过真实互动（点赞等）提升内容曝光与公信力，实现持续增长。`,
      create123: '评分',
      create124: '评论',
      create125: '该服务在此国家/地区不可用',
      create126: '每日最低评分数量为5',
      create127: '每日最低安装量为10',
      create128: '评分数量必须小于或等于安装数量',
      create129: '每个关键词长度不得超过180个字符',
      create130: '单个投放任务中的关键词必须互不相同',
      create131: `我们建议搜索关键词使用完整短语，
      例如：online shopping（在线购物）。如果有多个短语，
      建议点击右侧“添加”按钮分别添加`,
      create132: '密码与二次输入的密码不一致',
      create133: '最低金额为20美元',
      create134: '输入金额过大，请重新输入',
      create135: '请上传评论文件',
      create136: '请选择语言',
      create137: '不超过 500 KB',
      create138: '请再次输入密码',
      create139: '请选择推广任务类型',
      create140: '请填写取消投放任务的原因',
      create141: '交易ID不能为空',
      create142: '交易金额不能为空',
      create143: '交易日期不能为空',
      create144: '请输入金额',
      create145: '不超过 ',
      create146: '五星评分和评论',
      create147: '不能为空',
      create148: '请上传 jpg、png 格式图片，尺寸要求：1×1',
      create149: '最大 1 MB',
      create150: '宽 × 高：912 × 400',
      create151: '请上传 jpg、png 格式图片，要求： ',
      create152: '我们检测到您可能开启了广告拦截器，可能会导致部分功能异常，建议关闭',
      create153: '添加成功',
      create154: '注册成功',
      create155: '成功',
      create156: '失败',
      create157: '刷新成功',
      create158: '删除成功',
      create159: '复制成功',
      create160: '复制失败',
      create161: '开始',
      create162: '未选择推广应用',
      create163: '您也可以在首页添加目标应用',
      create164: '应用在商店中未找到',
      create165: '评价数量:',
      create166: '视频摘要：',
      create167: '用于生成评论的视频摘要',
      create168: '额外要求：',
      create169: '评论中需包含的关键词',
      create170: '可在此输入对评论内容的进一步要求',
      create171: '结果：',
      create172: '反馈：',
      create173: '重新编辑',
      create174: '订单说明',
      create175: '由于特殊原因，我们目前无法处理来自美国地区的在线任务投放。特此通知：美国地区最低投放量为1250。若需下单，请直接联系客服',
      create176: '使用AI生成评论',
      create177: '每次最多生成100条',
      create178: '编号',
      create179: '准备启动投放',
      create180: '准备开启投放之旅了吗？欢迎随时联系！',
      create181: '联系我们获取定制化方案，更有机会获得限时免费试用！',
      create182: '点击联系',
      create183: '预览',
      create184: '生成',
      create185: '免费试用',
      create186: '媒体类型',
      create187: 'Instagram 帖子横幅',
      create188: '图片（.jpg、.png），最大 500 KB，尺寸要求：1×1',
      create189: '图片（.jpg、.png），最大 1 MB',
      create190: '结束',
      create191: 'Likes&Dislikes',
      create192: 'User Name',
      create193: 'Review helpfulness vote',
      create194: '您的账户余额不足，还需充值',
      create195: '',
      create196: '美金 ',
      create197: '启动此推广任务。',
      create198: '提示',
      create199: '该推广活动需联系AM进行暂停和取消操作',
      create200: '操作成功',
      create201: '提交成功',
      create202: '发送成功',
      create203: '保存成功',
    },
    profile: {
      profile1: '联系方式',
      profile2: '发票抬头',
      profile3: 'Teams',
      profile4: '地址',
      profile5: '微信',
      profile6: 'Telegram',
      profile7: 'WhatsApp',
      profile8: '更改密码',
      profile9: '当前密码',
      profile10: '新密码',
      profile11: '确认新密码',
      profile12: '保存',
    },
    record: {
      record1: 'Stripe',
      record2: 'Payoneer（派安盈）',
      record3: '银行转账',
      record4: '消耗',
      record5: '退款',
      record6: '免费赠金',
      record7: '取消赠金',
      record8: '手动扣费',
      record9: 'Paypal',
      record10: '预付款',
      record11: 'ID',
      record12: '创建时间',
      record13: '详情',
      record14: '开发者',
    },
    deposit: {
      deposit1: '充值',
      deposit2: '单笔充值',
      deposit3: '奖励',
      deposit4: '推广任务期间，充值 100美元 可获得 100美元 + 8美元（8% 奖励）= 108美元；充值 1000美元 可获得 1000美元 + 120美元 = 1120美元',
      deposit5: '温馨提示：',
      deposit6: '1. 此奖励仅发放给创建ASO推广任务的用户。',
      deposit7: '2. ASOGrow保留对上述内容及条款的最终解释权。',
      deposit8: '例如，如果您支付500美元，您将获得500+25（5%奖励）=525美元；如果您支付1000美元，您将获得1000+100（10%奖励）=1100美元；如果您支付5000美元，您将获得5000+600（12%奖励）=5600美元！',
      deposit9: '1. 充值奖励仅可用于在ASOGrow平台上投放广告。如您申请退款，退款金额不包含该笔奖励金。',
      deposit10: '2. 此奖励仅发放给创建ASO推广任务的用户。',
      deposit11: '3. ASOGrow保留对上述内容及条款的最终解释权。',
      deposit12: '在线充值，首充即可获得奖励！充值 20美元 得 25美元，充值 50美元 得 60美元',
      deposit13: '如原充值金额在30天内未使用完，充值赠金将被收回，原充值金额不受影响。仅限首次充值有效',
      deposit14: '请选择支付方式',
      deposit15: '支付金额：',
      deposit16: '实际到账总额:',
      deposit17: '充值',
      deposit18: "本平台不会收集或保存您的任何支付凭证信息。",
      deposit19: '银行转账',
      deposit20: '我们已收到您的消息',
      deposit21: '通过表格提交转账信息，金额到账后可以更快地为您充值。', 
      deposit22: '交易 ID', 
      deposit23: '交易日期', 
      deposit24: '交易金额', 
      deposit25: '账户名称:', 
      deposit26: '银行账户:', 
      deposit27: '银行名称:', 
      deposit28: '银行地址:', 
      deposit29: 'SWIFT代码:', 
      deposit30: '银行代码:', 
      deposit31: '转账备注:', 
      deposit32: '复制转账信息', 
      deposit33: '余额变动记录', 
      deposit34: '更新时间', 
      deposit42: '重试',
      deposit43: '提交',
      deposit44: '1. 此支付方式的最低付款金额为',
      deposit441: '美元',
      deposit45: '2. 请确保填写完整',
      deposit46: '根据上述要求进行资金转账。',
      deposit47: '3. 付款后，您可以通过以下方式联系我们，以加快款项到账速度。',
      deposit48: '提示',
      deposit49: '请在新页面完成支付',
      deposit50: '订单已提交并正在处理中，请等待确认',
      deposit51: '返回选择其他支付方式',
      deposit52: '成功',
      deposit53: '您已充值成功，马上开始推广',
      deposit54: '查看支付记录',
      deposit55: '创建一个任务',
      deposit56: '失败',
      deposit57: '充值失败',
      deposit58: '',
      deposit59: '单笔充值满足以下条件即可获得额外奖励：',
      deposit60: 'PayPal 账户',
      deposit61: '账户地址',
      deposit62: 'Payoneer派安盈账户:',
      deposit63: '每页记录条数',
      deposit64: '搜索关键词',
      deposit65: '即日起',
      deposit66: '至',
    },
    price: {
      price2: '我们按不同的业务类型和地区收费。',
      price3: '计费项目',
      price4: '每种业务类型包含一个或多个付费项目，按项目单独计费，以下为各项服务价格。',
      price5: '服务',
    },
    other: {
      other1: '服务条款:',
      other2: '评分与评论是否保留取决于 Google Play 规则及应用状态，可能存在被移除的风险。',
      other3: '通常情况下，所有评分和评论将在推广任务结束后 24 小时内显示在 Google Play 上。',
      other4: "部分评分和评论可能会在 2-3 天内被 Google 移除，但在此之前仍可帮助提升应用的自然流量。",
      other5: '继续开启评分与评论订单即表示您同意承担相关风险 ',
      other6: '如发生应用下架情况，不支持退款',
      other7: '为避免被下架的情况',
      other8: '请遵循以下规则：',
      other9: '不要为新应用或安装量较少的应用大量添加评分和评论',
      other10: '新应用',
      other11: '或针对安装量较少的应用',
      other12: '评分数量不要超过总安装量的 10%–15%',
      other13: '评论数量不要超过评分总量的 5%',
      other14: '不要添加重复评论',
      other15: '不要发布过短的评论',
      other16: "评分与评论行为应模拟真实用户行为，并与应用在所选国家的自然流量比例保持一致，同时与当前已有评分和评论数量相匹配",
      other17: '示例 #1：100次安装 + 5个评分 + 3个评论的搭配安排',
      other18: '很合适',
      other19: '示例 #2：200 次安装 + 200 条评分用于新应用或没有任何评分的应用是',
      other20: '有风险的',
      other21: '1. 为减少被下架的情况，我们建议延长时间安排，而不是在一天内完成所有评论',
      other22: '为减少被下架的情况，评分数量应低于安装量的 15%。你可以增加安装数量',
      other23: '评论数量必须小于或等于评分数量',
      other24: "我已阅读并同意",
      other25: '《服务条款》',
      other26: '联系我们，领取限时折扣码',
      other27: '退出登录',
      other28: '获取更多自然流量用户',
      other29: '获取更多五星好评',
      other30: '提高应用评分',
      other31: '退出',
      other32: '请选择',
      other33: '请评价自动生成的评论的质量',
      other34: '请选择媒体类型',
      other35: '视频',
      other36: '为什么取消该推广任务？',
      other37: '推广任务将在两天内开始',
      other38: '推广任务将在付款后立即开始',
      other39: '使用',
      other40: 'ASOGrow',
      other41: '提升产品在Google Play商店的曝光',
      other42: '直接下载安装应用',
      other43: '关键词搜索优化',
      other44: '评分与评论优化',
      other45: '评论点赞',
      other46: '联系我们，您将获得',
      other47: '1. 专业的ASO优化服务',
      other48: '2. 为您的应用定制ASO优化方案',
      other49: '3. 意想不到的试用奖励',
      other50: '',
      other51: ' 的数量不能超过 ',
      other52: '自定义评论',
      other53: '五星好评',
      other54: '请选择',
      other55: '单笔充值金额',
      other56: '过去15天没有数据',
      other57: '* 只有在启动推广任务后才会产生数据记录, ',
      other58: '点击此处',
      other59: '创建您的推广任务',
      other60: '单击下面的图例进行切换',
      other61: '安装',
      reviews: '评论',
      ratings: '评分',
      attitude: '积极,满意,真诚,热情,赞扬',
      other62: '赠金',
      other63: '至',
      'Download,Open': '下载，打开',
      'Rating': '评分',
      'Custom Review': '自定义评论',
      'Search Keyword,Install and Open': '搜索关键词、安装并打开',
      'Review': '评论',
      'Likes to Review': '点赞评论',
      'Instagram Follow': 'Instagram关注者',
      'Instagram Post Like': 'Instagram帖子点赞',
      'Youtube Subscribe': '油管订阅',
      'Youtube Comment': '油管评论',
    },
    menu: {
      menu1: '我的应用',
      menu2: '推广任务',
      menu3: '创建任务',
      menu4: '我的任务',
      menu5: '充值',
      menu6: '账号记录',
      menu7: '我的账户',
      menu8: '常见问题',
      menu9: '帮助中心',
      menu10: '创建排名任务',
      menu11: '我的排名任务',
    },
    guide:{
      guide1: '点击“+”按钮，粘贴您的应用商店链接，即可获取您的应用推广方案',
      guide2: '查看您的应用推广任务',
      guide3: '选择您想要优化的内容',
      guide4: '免费创建第一个推广任务',
      guide5: '仅需1分钟即可创建你的推广任务，简单快捷',
      guide6: '查看数据统计',
      guide7: '跟踪数据变化，输出数据分析，帮助推广您的应用',
      guide8: '最后需要注意的是',
      guide9: '不要错过我们的充值赠金奖励',
      guide10: '新',
    },
    support: {
      support1: '1. 如何通过 ASOGrow 平台为您的应用获取自然流量用户？',
      support2: `我们致力于以经济实惠的价格助力您的应用实现自然下载量增长。
      - 通过在我们的平台上投放广告，您的应用可直接触达100%真实用户，无需任何第三方介入，从而让您的应用更加安全、更高效。
      - 我们确保所有安装、评分及评论均来自真实用户，且真实有效，保障应用安全无风险。`,
      support4: '2. 您的广告将在哪里展示？',
      support5: '您的推广任务将被投放至我们的积分墙应用 JadiDuit。了解或安装JadiDuit应用：https://jadiduit.id/',
      support6: '3. 什么是关键词搜索推广任务？',
      support7: `在关键词搜索推广中，用户将通过指定的目标关键词在 Google Play 进行搜索，找到您的应用并进行安装。
      因此，此类推广的重点是让更多自然流量用户在搜索目标关键词时发现您的应用。`,
      support8: '4. 什么是应用的关键词排名？',
      support9: '排名显示您的应用在特定关键词搜索结果中的位置，Google Play 和 App Store 搜索列表最多显示 250 个应用，提升排名意味着更高曝光。',
      support10: '5. 什么是评分与评论推广任务？',
      support11: `在评分与评论推广中，用户将在 Google Play 为您的应用留下评分和评论。正面评论有助于吸引更多用户。
      请注意：若用户不喜欢应用或认为不安全，可能会卸载并留下负面评价。仅正面评论视为有效转化。`,
      support12: '6. 我们如何计算价格？',
      support13: `每个项目单独计费，每个项目的价格因国家而异。
      安装并打开、关键词搜索、安装并打开、点赞和评论都是独立的项目。
      “安装、打开并评分”的价格 = 安装 + 评分
      “安装、打开、评分并评论”的价格 = 安装 + 评分 + 评论`,
      support14: '7. 我可以删除或暂停推广任务吗？',
      support15: `当然，您可以自行暂停推广任务。
      找到该推广任务并点击【暂停】
      注意：暂停您的广告系列需要几分钟时间，在此期间产生的任何安装费用都将计入账单，直至您的广告系列成功结束。`,
      support16: '8. 我在创建推广任务后可以更改我的设置吗？',
      support17: '不可以，广告系列投放期间无法编辑。但您可以暂停该广告系列并创建一个新的广告系列。',
      support18: '9. 您的广告系列何时会由系统自动暂停？',
      support19: `1. 系统检测到较高的欺诈风险
      2. 转化率过低，这表明您的应用或跟踪系统存在一些技术问题。`,
      support20: '10. Google Play 上何时会显示下载量？',
      support21: '请注意，这可能需要长达24至36小时（有时甚至更久，具体取决于Google Play自身的算法）。',
      support22: '11. 推广任务什么时候开始？',
      support23: '您需要自行设置推广任务的开始时间；当推广任务处于启用状态且到达设定的开始时间时，您的活推广任务将自动启动。',
      support24: '12. 我该如何获得退款？',
      support25: `如需申请退款，您可通过电子邮件、Teams 或 WhatsApp 联系我们，并告知我们退款原因。
      请注意，我们只能退还主账户余额的资金，奖励金余额的资金不予退还。`,
      support26: '13. 如果我没有看到安装记录，该怎么办？',
      support27: `如果您已在 Google 开发者平台中查看了您的安装数据，但并非所有安装都已显示，请确保相关订单是在 2 至 3 天前下达的，因为应用商店通常需要这段时间才能将这些安装数据同步到统计中。
      如果在订单完成后2至3天内您的安装仍未显示，请随时通过您方便的任何沟通渠道与我们联系。我们的客服人员将为您说明原因并协助解决问题。`,
      support28: '14. 平台目前支持推广付费应用吗？',
      support29: '很抱歉给您带来不便，目前我们仅支持推广已在 Google Play 上架的免费应用。',
      support30: '如何计算价格',
      support31: '我们按不同的业务类型和地区收费。',
      support32: '注意',
      support33: '是',
      support34: '否',
      support35: '正在生成评论内容，请您耐心等候...',
      support36: 'AI 长评论生成失败，请重试或减少评论条数，可降低生成失败概率。',
      support37: '',
      support38: ' 美元',
    },
    noknow:{
      noknow1: '用Emoji评论：',
    },
    createCampaignBrush: {
      typeIndustryListRanking: '行业榜单排名',
      typeGuaranteedKeywordRanking: '关键词排名',
      os: '设备',
      googlePlay: 'Google Play',
      appStoreIPhone: 'IPhone',
      appStoreIPad: 'IPad',
      ranking: '排名',
      top1: 'Top1',
      top2: 'Top2',
      top3: 'Top3',
      top1To3: 'Top1-3',
      top4To6: 'Top4-6',
      top7To12: 'Top7-12',
      top13To25: 'Top13-25',
      top26To35: 'Top26-35',
      top36To50: 'Top36-50',
      promoteDays: '投放天数',
      weeks2: '2周',
      weeks3: '3周',
      more: '更多',
      cap: 'Cap',
      contact: '联系方式',
      teams: 'Teams',
      brush1: '1、请确保您的应用在这些搜索关键词中的排名进入前250名；否则用户将无法找到您的应用。',
      brush2: '2、使用引号、正斜杠、井号或特殊字符来区分关键词。',
      brush3: '请正确填写您的联系方式。我们需要和您沟通确认后才能开启任务',
      brush4: '提交推广计划后，请保持联系方式畅通。',
      brush5: '这是订金。具体推广金额以沟通为准，多退少补',
      brush6: '订金',
      brush7: '这是预付订金。',
      brush8: '您的最终需求与排期将根据双方沟通进行定制。价格实行多退少补。',
      appleLinkErr: '请输入合法的 App Store 链接',
      contentTip1:'通过特定关键词安装提升关键词排名和自然流量。',
      contentInfo1:'本服务产生的安装并非来自真实用户。因此，其互动质量、用户行为模式以及排名提升的长期稳定性，可能与自然用户有所不同。我们建议主要将其作为综合营销策略中的补充。',
      contentTip2:'这种ASO策略目标是提升目标APP在分类排行榜（如“金融”）的排名，以增加曝光度和自然下载量。',
      contentInfo2:`该服务帮助应用在应用商店的某个分类排行榜（如“金融”）上达到指定位置，从而大幅提升曝光度，带动大量自然下载。这种方式尤其适合新应用上线、重大版本更新，或在特定地区、子类目下做定向推广。`,
      contentTip3:'基于效果结算的ASO服务，确保应用在选定关键词上达到指定排名，如果没有达到目标，支持退款。',
      contentInfo3:"ASO服务内容：保证在官方商店的目标关键词搜索结果中，达到并维持指定排名（如前三名）。服务按效果付费，有明确的KPI和退款条款。该服务非常适合成熟应用获取高价值流量。",
    },
  },
}
